import React from "react";
import {cva} from "class-variance-authority";
import {cn} from "../../utils/cn";

const pillVariants = cva(
  "inline-flex items-center gap-1.5 font-semibold rounded-full whitespace-nowrap",
  {
    variants: {
      tone: {
        success: "bg-success-100 text-success-700",
        danger: "bg-danger-100 text-danger-700",
        warning: "bg-warning-100 text-warning-700",
        info: "bg-info-100 text-info-700",
        neutral: "bg-ink-100 text-ink-700",
        brand: "bg-brand-100 text-brand-700",
      },
      size: {
        sm: "px-2 py-0.5 text-2xs",
        md: "px-2.5 py-0.5 text-xs",
        lg: "px-3 py-1 text-sm",
      },
    },
    defaultVariants: {tone: "neutral", size: "md"},
  }
);

const dotColor = {
  success: "bg-success-500",
  danger: "bg-danger-500",
  warning: "bg-warning-500",
  info: "bg-info-500",
  neutral: "bg-ink-400",
  brand: "bg-brand-500",
};

/**
 * Status pill. Use `dot` for live state (Online / Offline), omit for static state (Active).
 * `pulse` adds the gentle pulse animation for realtime indicators.
 */
export default function Pill({tone = "neutral", size = "md", dot = false, pulse = false, className, children, ...props}) {
  return (
    <span className={cn(pillVariants({tone, size}), className)} {...props}>
      {dot && (
        <span
          className={cn(
            "h-1.5 w-1.5 rounded-full",
            dotColor[tone],
            pulse && "animate-pulse-dot"
          )}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
}
